const CONSUMER_SESSION_APPOINTMENT = "GGTAppointment";
const CONSUMER_SESSION_AUTH = "GGTAuthorization";
const CONSUMER_SESSION_LOCATION = "GGTLocation";
const CONSUMER_SESSION_NOVERIFY = "NOVERIFY";
const CONSUMER_SESSION_REDIRECT_TO = "RedirectTo";
const CONSUMER_SESSION_VERIFICATION_TOKEN = "VerificationToken";
const CONSUMER_SESSION_PREFERENCES = "Preferences";

export {
  CONSUMER_SESSION_APPOINTMENT,
  CONSUMER_SESSION_AUTH,
  CONSUMER_SESSION_LOCATION,
  CONSUMER_SESSION_NOVERIFY,
  CONSUMER_SESSION_REDIRECT_TO,
  CONSUMER_SESSION_VERIFICATION_TOKEN,
  CONSUMER_SESSION_PREFERENCES
};
